import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import CustomDashboardsAPI from '../../api/customDashboards';
import { throwErrorMessage } from '../utils/api';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isDeleting: false,
    isUpdating: false,
  },
  // Variable to store if requisition was made in component mount
  // Covering cases where customer opens custom_dashboard using a link and secondary menu is not open
  fetchedRecordsOnMount: false,
};

export const getters = {
  getCustomDashboards($state) {
    return $state.records;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getFetchedRecordsOnMountState($state) {
    return $state.fetchedRecordsOnMount;
  },
};

export const actions = {
  get: async ({ commit }, fetchingRecordsOnMount = false) => {
    if (fetchingRecordsOnMount) commit('SET_FETCHED_DASHBOARDS_ON_MOUNT');
    commit(types.SET_CUSTOM_DASHBOARDS_UI_FLAG, { isFetching: true });
    try {
      const response = await CustomDashboardsAPI.get();
      commit(types.SET_CUSTOM_DASHBOARDS, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_CUSTOM_DASHBOARDS_UI_FLAG, { isFetching: false });
    }
  },
  create: async ({ commit }, payload) => {
    commit(types.SET_CUSTOM_DASHBOARDS_UI_FLAG, { isCreating: true });
    try {
      const response = await CustomDashboardsAPI.newCustomDashboard(payload);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_CUSTOM_DASHBOARDS_UI_FLAG, { isCreating: false });
    }
    return null;
  },
  update: async ({ commit }, { id, payload }) => {
    commit(types.SET_CUSTOM_DASHBOARDS_UI_FLAG, { isUpdating: true });
    try {
      await CustomDashboardsAPI.updateCustomDashboard(id, payload);
      // commit(types.EDIT_AGENT_BOT, response.data);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_CUSTOM_DASHBOARDS_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit(types.SET_CUSTOM_DASHBOARDS_UI_FLAG, { isDeleting: true });
    try {
      await CustomDashboardsAPI.delete(id);
      commit(types.DELETE_CUSTOM_DASHBOARD, id);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_CUSTOM_DASHBOARDS_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_CUSTOM_DASHBOARDS_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.SET_CUSTOM_DASHBOARDS]: MutationHelpers.set,
  // [types.EDIT_AGENT_BOT]: MutationHelpers.update,
  [types.DELETE_CUSTOM_DASHBOARD]: MutationHelpers.destroy,

  // FLAG TO STOP UNNECESSARY REQUESTS
  // Multiple components can request the same data based on mount configuration
  SET_FETCHED_DASHBOARDS_ON_MOUNT($state) {
    $state.fetchedRecordsOnMount = true;
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
